export default __webpack_public_path__ + "532355049b78fdeeba6128acbcf13f59.png";